/**
 * Pay as you go: the balance is prepaid USD credit, kept in cents. Every sent
 * email (first touch, follow-up or a reply) costs the same; nothing else is
 * charged.
 */
export const CREDIT_PRICE_PER_EMAIL_CENTS = 5;
/** The price per email in USD, as shown to customers ($0.05). */
export const GTM_PRICE_PER_EMAIL_USD = CREDIT_PRICE_PER_EMAIL_CENTS / 100;
/** Emails a balance pays for at the current price per email. */
export function emailsForCents(amountCents) {
    return Math.floor(Math.max(amountCents, 0) / CREDIT_PRICE_PER_EMAIL_CENTS);
}
/** In-app top-ups: any whole USD amount within these bounds. */
export const CREDIT_TOP_UP_LIMITS = {
    minUsd: 50,
    maxUsd: 10_000,
};
/** Unused credits of a top-up can be refunded for this many days after payment. */
export const CREDIT_REFUND_WINDOW_DAYS = 14;
/** The balance is "low" once it is forecast to run out within this many days. */
export const CREDIT_LOW_BALANCE_DAYS = 3;
/** Trailing window of spending the run-out forecast is based on. */
export const CREDIT_FORECAST_WINDOW_DAYS = 14;
//# sourceMappingURL=credits.constants.js.map